export { default as EditorPage } from './lib/EditorPage/EditorPage.vue'
